import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=d8a9017c&scoped=true"
import script from "./UpdatePassword.vue?vue&type=script&lang=js"
export * from "./UpdatePassword.vue?vue&type=script&lang=js"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=d8a9017c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a9017c",
  null
  
)

export default component.exports